import {Box, styled} from '@mui/material';

export const DownloadContainer = styled(Box)`
	border-radius: 8px;
	border: 1px solid ${({theme}) => theme.palette.grey[300]};
	background: ${({theme}) => theme.palette.grey[100]};
	padding: 0px 8px 0px 16px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 8px;
`;
